import chainData from "../chains.js";
import {BGTI} from "../abi/BGTI.js";
import {AMNAbi} from "../abi/AuctionManagerNew.js";
import {ethers} from "ethers";
import {viriMultiCall} from "../abi/ViriMultiCall.js";

/**
 * @module components/getTokens
 * @category Utilities
 */

/**
 * Fetches tokens held by an owner for a given contract.
 *
 * Queries BGTI (Boosted Gem Token Indexer) and AuctionManager for tokens:
 * - collectionTokens: tokens directly owned by the user from the contract
 * - auctionTokens: tokens that are in auctions managed by the AuctionManager
 *
 * @async
 * @param {string} owner - Owner address to query
 * @param {number} network - Chain ID (index into chainData)
 * @param {string} contract - NFT contract address
 * @param {ethers.providers.Provider} prov - Ethers provider instance
 * @returns {{collection: {tokens: array, ids: array}, auction: {tokens: array, ids: array}}|null}
 *          Object with token data or null on error
 */
export const getHeldTokens = async (owner, network, contract, prov) => {
   try {
       let netInf = chainData[network];
//console.log(prov)
       //let prov = new ethers.providers.JsonRpcProvider(netInf.rpc)

       let bgc = new ethers.Contract(netInf.bgti, BGTI, prov);
       let amc = new ethers.Contract(netInf.aManager, AMNAbi, prov);

       await bgc.deployed();
       await amc.deployed();


       let moreTokens = true;

       let cTokens = [];
       let aTokens = [];
       let cIds = [];
       let aIds = [];

       let time1 = Date.now();

       while (moreTokens) {
           let op = await bgc.SpecificTokens(contract, owner, 0, 150)
           for (const [k, v] of Object.entries(op.returnData)) {
               cTokens.push({url: v.URI, owner: v.Owner, id: v.tid.toString()})
               cIds.push(parseInt(v.tid.toString()))
           }
           //cTokens = [...cTokens, ...op?.returnData]
           moreTokens = op?.moreTokens;
       }


       moreTokens = true;

       while (moreTokens) {
           let op = await bgc.AMTokens(contract, owner, netInf.aManager, 0, 150)
           for (const [k, v] of Object.entries(op.returnData)) {
               aTokens.push({url: v.URI, owner: v.Owner, id: v.tid.toString()})
               aIds.push(parseInt(v.tid.toString()))

           }
           moreTokens = op?.moreTokens;
       }

       let time2 = Date.now()

       let elapsed = time2 - time1

       return ({collection: {tokens: cTokens, ids: cIds}, auction: {tokens: aTokens, ids: aIds}})
   } catch (e) {
       return null;
   }


}

/**
 * Performs a multicall to read data from multiple contracts in a single RPC call.
 *
 * Encodes function calls using ABI coder and aggregates them via the MultiCall contract.
 *
 * @param {number} network - Chain ID (index into chainData)
 * @param {Array<{addr: string, call: array, types: string}>} args - Array of call arguments
 *        Each entry must contain:
 *        - addr: contract address
 *        - call: array of function arguments to encode
 *        - types: ABI type string (e.g., 'uint256,address')
 * @returns {Promise<void>} This function doesn't return a value; results are read from the contract state
 */
export const ViriMultiCallRead = (network, args) =>{
    let netInf = chainData[network];
    let prov = new ethers.providers.JsonRpcProvider(netInf.rpc)
    let mcc = new ethers.Contract(netInf.MultiCall, viriMultiCall, prov);


    let fuk = new ethers.utils.AbiCoder();

    // encode the args
    for(let i=0;i<args.length;i++){
        let addr = args[i].addr // can be plain address
        let call = args[i].call //
        let types = args[i].types

        let _types=types

        let encCall = fuk.encode([_types], call)


        mcc.agg_read(args[i].addr, encCall)
    }


}

